module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-thin-straight-2YUSDJEW.woff2?eaff449f0b716b514fd3a9c6cda1583f";